if (process && process.env && process.env.NODE_ENV !== 'production') {
    console.log(
        '%c Running Dev build: bundle.quick-view',
        'background:red; color:white; font-size:16px;'
    );
}

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import globalStore from 'state/configure-store';
import { QuickView } from 'components';
import { logger } from 'packages';
import './quick-view-modal.scss';

const mountQuickView = El => {
    if (El) {
        try {
            render(
                <Provider store={globalStore}>
                    <QuickView />
                </Provider>,
                El
            );
        } catch (e) {
            logger(e);
        }
    }
};
export default () => {
    const El = Array.from(document.querySelectorAll('#quick-view'));

    if (El) {
        mountQuickView(El[0]);
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/quick-view/index.js